import { c as _c } from "react/compiler-runtime";
import { ElementType, ReactNode } from 'react';
import MuiFormLabel, { FormLabelProps as MuiFormLabelProps } from '@mui/material/FormLabel';
import MuiFormHelperText from '@mui/material/FormHelperText';
import HelpIcon from '@mui/icons-material/Help';
import { styled } from '../styles';
import Typography from '../Typography';
import Tooltip from '../Tooltip';
const SubLabel = styled(MuiFormHelperText)(({
  theme: {
    typography
  }
}) => ({
  fontSize: typography.helper.fontSize,
  letterSpacing: typography.helper.letterSpacing,
  lineHeight: typography.helper.lineHeight,
  fontWeight: typography.helper.fontWeight,
  flexBasis: '100%',
  margin: 0
}));
const TooltipIcon = styled(HelpIcon)(({
  theme: {
    palette
  }
}) => ({
  height: 15,
  width: 15,
  verticalAlign: 'text-top',
  color: palette.icon.minor
}));
const Optional = styled('span')(({
  theme: {
    palette
  }
}) => ({
  color: palette.text.onMainMinor
}));
const Wrapper = styled('span')(({
  theme: {
    spacing
  }
}) => ({
  '& > *:not(:last-child)': {
    marginRight: spacing(0.5)
  }
}));
const StyledFormLabel = styled(MuiFormLabel, {
  shouldForwardProp: prop => !['hasSubLabel', 'isOptionalShown'].includes(prop as string)
})<{
  hasSubLabel: boolean;
  isOptionalShown: boolean;
}>(({
  theme: {
    palette,
    typography,
    spacing
  },
  hasSubLabel
}) => ({
  '&': {
    display: 'inline-block',
    ...typography.label,
    color: palette.form.label.empty,
    marginBottom: hasSubLabel ? spacing(0.5) : spacing(1)
  },
  '&.Mui-disabled': {
    color: palette.form.label.disabled
  },
  '&.MuiFormLabel-filled': {
    color: palette.form.label.filled
  },
  '&.Mui-error': {
    color: palette.form.label.error
  }
}));
export interface Props extends MuiFormLabelProps {
  sublabel?: ReactNode;
  component?: ElementType;
  hint?: string;
  isOptionalShown?: boolean;
  translations?: {
    optional: string;
  };
}
const FormLabel = t0 => {
  const $ = _c(28);
  let children;
  let hint;
  let props;
  let sublabel;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      sublabel,
      children,
      isOptionalShown: t1,
      translations: t2,
      hint,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = hint;
    $[3] = props;
    $[4] = sublabel;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    hint = $[2];
    props = $[3];
    sublabel = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const isOptionalShown = t1 === undefined ? false : t1;
  let t3;
  if ($[7] !== t2) {
    t3 = t2 === undefined ? {
      optional: "optional"
    } : t2;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const translations = t3;
  const t4 = Boolean(sublabel);
  let t5;
  if ($[9] !== children) {
    t5 = <span>{children}</span>;
    $[9] = children;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== hint) {
    t6 = hint && <Tooltip content={hint}><TooltipIcon /></Tooltip>;
    $[11] = hint;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isOptionalShown || $[14] !== translations) {
    t7 = isOptionalShown && <Typography component={Optional} variant="label">({translations.optional})</Typography>;
    $[13] = isOptionalShown;
    $[14] = translations;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <Wrapper>{t5}{t6}{t7}</Wrapper>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== sublabel) {
    t9 = sublabel && <SubLabel>{sublabel}</SubLabel>;
    $[20] = sublabel;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isOptionalShown || $[23] !== props || $[24] !== t4 || $[25] !== t8 || $[26] !== t9) {
    t10 = <StyledFormLabel hasSubLabel={t4} isOptionalShown={isOptionalShown} {...props}>{t8}{t9}</StyledFormLabel>;
    $[22] = isOptionalShown;
    $[23] = props;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default FormLabel;